export const POP_UP_VISIBLE = 'POP_UP_VISIBLE';
export const POP_UP_IMAGE = 'POP_UP_IMAGE';
export const POP_UP_WIDTH = 'POP_UP_WIDTH';
